import { CityPaymentScopeDtoEnum } from './create-checkout-session.dto';

export enum AdminCityPurchaseProviderEnum {
    STRIPE = 'stripe',
    IAP = 'iap',
    CLOUDPAYMENTS = 'cloudpayments',
}

export type AdminCityPurchasePlayerRO = {
    id: number;
    email: string;
    fullName: string | null;
    lastLoginAt: string | null;
    emailVerifiedAt: string | null;
    createdAt: string;
};

export type AdminCityPurchaseProductRO = {
    scope: CityPaymentScopeDtoEnum;
    scopeId: number | null;
    title: string;
    cityId: number | null;
    cityTitle: string | null;
    coverUrl: string | null;
};

export type AdminCityPurchasePartnerRO = {
    id: number;
    name: string;
    companyName: string | null;
    email: string | null;
    promocode: string | null;
};

export type AdminCityPurchasePromoClaimRO = {
    id: number;
    code: string;
    discountPercent: number;
    claimedAt: string | null;
    attributedPurchaseCount: number;
};

export type AdminCityPurchaseEntitlementRO = {
    id: number;
    source: string;
    expiresAt: string | null;
    revokedAt: string | null;
    storeTransactionId: string | null;
    createdAt: string;
};

export type AdminCityPurchaseConsentRO = {
    id: number;
    email: string;
    docsVersion: string;
    locale: string | null;
    checkoutSessionId: string | null;
    createdAt: string;
};

export type AdminCityPurchaseCommissionRO = {
    id: number;
    status: string;
    commissionCents: number;
    commissionPercent: number;
    availableAt: string | null;
    payoutId: number | null;
    createdAt: string;
};

/** Row for the purchases table. */
export type AdminCityPurchaseListItemRO = {
    id: number;
    createdAt: string;
    provider: AdminCityPurchaseProviderEnum;
    scope: CityPaymentScopeDtoEnum;
    scopeId: number | null;
    title: string;
    cityId: number | null;
    cityTitle: string | null;
    amountPaidCents: number;
    taxCents: number;
    currency: string;
    refundedAt: string | null;
    externalId: string;
    player: Pick<AdminCityPurchasePlayerRO, 'id' | 'email' | 'fullName'>;
    partner: Pick<AdminCityPurchasePartnerRO, 'id' | 'name' | 'companyName'> | null;
    commissionCents: number | null;
    commissionPercent: number | null;
};

/** Full detail for the purchase drawer. */
export type AdminCityPurchaseDetailRO = AdminCityPurchaseListItemRO & {
    updatedAt: string;
    promoClaimId: number | null;
    player: AdminCityPurchasePlayerRO;
    product: AdminCityPurchaseProductRO;
    partner: AdminCityPurchasePartnerRO | null;
    promoClaim: AdminCityPurchasePromoClaimRO | null;
    entitlement: AdminCityPurchaseEntitlementRO | null;
    consent: AdminCityPurchaseConsentRO | null;
    commission: AdminCityPurchaseCommissionRO | null;
    playerPurchaseCount: number;
};
